import { Category } from "../types";
import fetchContentType from "../utils";

export const categoriesPerPage = 16;

export const getCategories = async (page: number, pageSize = categoriesPerPage) => {
  return fetchContentType<{
    data: Category[];
    meta: { pagination: { total: number } };
  }>(
    "categories",
    {
      pagination: {
        page,
        pageSize,
      },
      populate: "*",
      sort: ["name:asc"],
    },
    false,
  );
};
